import styled from "styled-components";

interface RowProps {
  reverse?: boolean;
}

export const PageWrapper = styled.div`
  background: #02317c;
  position: relative;
  overflow: hidden;
`;
export const BestRateSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 120px 0;
  align-items: center;
  background-color: #f7fbff;

  .title-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;
  }
  .title-box .desc {
    color: #525252;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
  }
  .title-box .title {
    color: #212529;
    font-family: "Roboto Serif";
    font-size: 56px;
    font-style: normal;
    font-weight: 500;
    line-height: 64px;
    text-align: center;
    margin-bottom: 16px;
  }

  @media (max-width: 768px) {
    .title-box .title {
      font-size: 36px;
    }
  }
`;

export const BestRateSlider = styled.div`
  overflow-x: hidden;
  overflow-y: visible;
  width: 100%;
  position: relative;

  .marquee {
    padding: 80px 0;
    display: flex;
    gap: 40px;
    animation: marquee 20s linear infinite alternate;
  }

  @keyframes marquee {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-55%);
    }
  }
`;

export const RateSliderBox = styled.div`
  flex: 0 0 auto;
  border-radius: 30px;
  background: #fff;
  box-shadow:
    0 8px 20px 0 rgba(0, 0, 0, 0.1),
    0 4px 15px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 466px;
  height: 600px;

  .text-box {
    height: 300px;
    padding: 25px;
    h4 {
      margin-bottom: 24px;
    }
    p {
      text-align: left;
    }
  }

  .icon-box {
    border-radius: 30px 30px 0 0;
    height: 300px;
    background: #f8fbff;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 64px 0;
  padding-top: 70px;

  img {
    max-width: 580px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0px 0 80px;
    img {
      max-width: 100%;
    }
  }
`;
export const Slider = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  width: 100%;
  margin-bottom: 80px;
  margin-top: 120px;

  @media (min-width: 768px) {
    justify-content: space-around;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
`;

export const SliderBox = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  text-align: center;
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: 25.5px;
  color: #212529;

  @media (min-width: 1200px) {
    width: 230px;
  }

  @media (min-width: 992px) and (max-width: 1199px) {
    width: 30%;
    min-width: 200px;
  }

  @media (min-width: 768px) and (max-width: 991px) {
    width: 45%;
    min-width: 180px;
  }

  @media (max-width: 767px) {
    width: 100%;
    max-width: 300px;
  }
`;

export const TopSectionMain = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  .text-box {
    text-align: left;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  .desc-box {
    position: absolute;
    bottom: 20px;
    left: -70px;
    display: flex;
    width: 305px;
    padding: 20px 32px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 30px 0 30px 30px;
    background: linear-gradient(180deg, #fff 0%, rgba(255, 255, 255, 0.9) 100%);
    box-shadow: 0 17px 72.2px 0 rgba(6, 32, 62, 0.3);
  }

  h1 {
    font-size: 54px;
    font-family: "Roboto Serif", serif;
    font-weight: 600;
    line-height: 1.1;
    margin-bottom: 20px;
    color: #fff;
  }

  p {
    font-size: 17px;
    color: #333333;
    line-height: 25px;
    letter-spacing: 0.5px;
    text-align: center;
  }

  .home-p {
    font-family: sans-serif;
  }

  @media (max-width: 991px) {
    flex-direction: column;
    margin-top: 100px;
    h1 {
      font-size: 36px;
      font-weight: 700;
      line-height: 44px;
      margin-bottom: 24px;
    }
    .desc-box {
      left: -20px;
    }

    p {
      margin-bottom: 24px;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SectionContent = styled.div`
  padding: 80px 0px;
  text-align: center;

  h2 {
    font-size: 40px;
    line-height: 50px;
    color: #212529;
    font-weight: 700;
  }

  h3 {
    font-size: 24px;
    line-height: 30px;
    color: #299b85;
    font-weight: 700;
  }

  p {
    max-width: 460px;
    display: block;
    margin: 0 auto 20px;
    font-size: 16px;
    line-height: 24px;
    color: #666666;
  }

  @media (max-width: 768px) {
    padding: 40px 0;

    h2 {
      font-size: 22px;
    }

    p {
      max-width: 100%;
    }

    button {
      margin-bottom: 15px;
    }
  }
`;

export const PartnerSection = styled.div`
  padding: 80px 0;

  h2 {
    text-align: center;
    font-weight: 700;
    font-size: 36px;
    line-height: 42px;
    max-width: 50%;
    display: block;
    margin: 0 auto 30px;
  }

  @media (max-width: 768px) {
    padding: 40px 0;

    h2 {
      max-width: 80%;
      font-size: 22px;
      line-weight: 36px;
    }
  }
`;
export const ProgramSection = styled.div`
  padding-top: 120px;
  padding-bottom: 120px;
  background: #002c66;
  h4 {
    font-size: 24px;
    color: #fff;
    text-align: center;
    font-weight: 500;
    margin-bottom: 18px;
  }

  h3 {
    color: #82c0ff;
    font-family: "Roboto Serif";
    font-size: 40px;
    text-align: center;
    font-weight: 500;
    line-height: 50px;
    width: 50%;
    margin: 0 auto 18px;
    margin-bottom: 54px;
  }

  @media (max-width: 768px) {
    padding-top: 80px;
    padding-bottom: 80px;

    h4 {
      font-size: 20px;
      font-weight: 700;
      line-height: 30px;
    }
    h3 {
      width: 100%;
      font-size: 28px;
      line-height: 36px;
    }
  }
`;
export const AnswerSection = styled.div`
  padding-top: 120px;
  padding-bottom: 120px;
  background: #eff6fd;
`;

export const AnswerSectionContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 64px;
  h2 {
    color: #212529;
    font-family: "Roboto Serif";
    font-size: 56px;
    font-style: normal;
    font-weight: 500;
    line-height: 60px; /* 107.143% */
    letter-spacing: -1.12px;
    margin-bottom: 32px;
  }

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const AnswerSectionRow = styled.div`
  display: flex;
  width: 100%;
  padding: 32px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border-radius: 30px;
  background: #fff;
  box-shadow:
    0 8px 20px 0 rgba(0, 0, 0, 0.1),
    0 4px 15px 0 rgba(0, 0, 0, 0.05);
  p {
    color: #5d6d7e;
    text-overflow: ellipsis;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 30.72px;
  }
  .text-box {
    display: flex;
    gap: 16px;
    color: #212529;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
  }
`;

export const SectionRow = styled.div<RowProps>`
  display: flex;
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "row")};
  align-items: center;
  justify-content: space-between;
  background: #023077;
  border-radius: 16px;
  box-shadow: 0 8px 25px 0 rgba(0, 0, 0, 0.05);
  margin-bottom: 30px;

  @media (max-width: 1000px) {
    flex-direction: column;
    padding: 22px;
  }
`;
export const ProgramSectionContent = styled.div`
  padding: 0 44px;
  display: flex;
  flex-direction: row;
  gap: 40px;

  h2 {
    color: #fff;
    font-family: "Roboto Serif";
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 38.4px; /* 120% */
  }

  p {
    color: #f5f8ff;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }

  button {
    margin-left: auto;
    display: block;
  }
  .step-title {
    width: 200px;
    color: #82c0ff;
    font-family: "Roboto Serif";
    font-size: 56px;
    font-style: normal;
    font-weight: 500;
    line-height: 40px; /* 71.429% */
    letter-spacing: -1.12px;
  }

  @media (max-width: 768px) {
    padding-left: 0;
    padding-right: 0;

    h2 {
      font-size: 22px;
    }

    button {
      margin-bottom: 15px;
      width: 100%;
    }
  }
`;

export const SectionImg = styled.div`
  flex-shrink: 0;
  flex-basis: 25%;
  img {
    max-height: 280px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const ProvidersSection = styled.div`
  background: #f7fbff;
  padding: 60px 0 0;
  border-top: 1px solid #e4effc;

  .providers-label {
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #7a9cbf;
    margin-bottom: 32px;
  }

  .logos-row {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 40px;
  }

  .logo-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 240px;
    height: 120px;
    flex-shrink: 0;
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 2px 12px 0 rgba(2, 49, 124, 0.07);
    transition:
      box-shadow 0.2s ease,
      transform 0.2s ease;

    img {
      width: 180px;
      height: 90px;
      object-fit: contain;
      filter: grayscale(30%);
      opacity: 0.9;
      transition:
        filter 0.2s ease,
        opacity 0.2s ease;
    }

    &:hover {
      box-shadow: 0 6px 24px 0 rgba(2, 49, 124, 0.13);
      transform: translateY(-2px);

      img {
        filter: grayscale(0%);
        opacity: 1;
      }
    }
  }

  @media (max-width: 600px) {
    padding: 40px 0 0;

    .logos-row {
      gap: 20px;
    }

    .logo-item {
      width: 160px;
      height: 90px;

      img {
        width: 120px;
        height: 70px;
      }
    }
  }
`;
